module.exports = __webpack_public_path__ + "static/media/Collect.b0100255.svg";